import React from 'react';
import { useParams } from 'react-router';

import { ClubRoute, MemberRoute, UserClubRole } from '@swf/core/types/Poker';
import { MainNav, useCheckUserClubRole, useGetContentRoutes } from '@swf/poker';

import { TXTCLI_Blocked, TXTCLI_Members, TXTCLI_Pending } from './Tabs.messages.json';
import styles from './Tabs.scss';

const Tabs = () => {
  const { clubsPath } = useGetContentRoutes();
  const { clubId } = useParams<{ clubId: string; section: string; subsection: string }>();

  const isAdminOrManager = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);

  const links = [
    {
      translation: TXTCLI_Members,
      href: `${clubsPath}/${clubId}/${ClubRoute.Members}/${MemberRoute.List}`
    },
    {
      translation: TXTCLI_Pending,
      href: `${clubsPath}/${clubId}/${ClubRoute.Members}/${MemberRoute.Pending}`
    },
    {
      translation: TXTCLI_Blocked,
      href: `${clubsPath}/${clubId}/${ClubRoute.Members}/${MemberRoute.Blocked}`
    }
  ];

  if (isAdminOrManager) {
    return <MainNav links={links} innerClassName={styles.container} />;
  }

  return null;
};

export default Tabs;
